
export const JCBIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='37'
    height='22'
    fill='none'
    viewBox='0 0 37 22'
  >
    <path
      fill='#EBF1F8'
      d='M2.604 0h32.314a2.034 2.034 0 0 1 2.033 2.033v17.761a2.033 2.033 0 0 1-2.033 2.033H2.604a2.034 2.034 0 0 1-2.033-2.033V2.034A2.034 2.034 0 0 1 2.604 0'
    />
    <path
      fill='#016AB6'
      d='M10.5 2.168h2.865v13.225a4.345 4.345 0 0 1-4.345 4.345H6.156V6.53a4.345 4.345 0 0 1 4.328-4.362z'
    />
    <path
      fill='#fff'
      d='m10.23 8.29 2.492-.024.017 3.687s.104 1.61-2.2 2.027c-1.47.232-2.975.142-4.407-.264q-.031-.621 0-1.241s2.916 1.484 3.903 0a.93.93 0 0 0 .156-.511z'
    />
    <path
      fill='#C6283F'
      d='M19.044 2.168h2.864v13.225a4.344 4.344 0 0 1-4.341 4.345h-2.864V6.53a4.345 4.345 0 0 1 4.327-4.362z'
    />
    <path
      fill='#fff'
      d='M21.102 8.503v1.23s-1.498-.82-2.98-.618c-1.48.201-2.519 1.995-1.15 3.527 0 0 1.262 1.147 4.112-.132v1.179s-4.004 1.279-6.392-.543V9.038s1.804-1.675 6.41-.535'
    />
    <path
      fill='#36A239'
      d='M27.55 2.168h2.877v13.225a4.345 4.345 0 0 1-4.344 4.345h-2.864V6.53a4.345 4.345 0 0 1 4.344-4.345z'
    />
    <path
      fill='#fff'
      d='m23.208 8.34-.024 5.666 4.883-.028s1.644-.215 1.547-1.505c0-.055.139-1.147-1.697-1.414 0 0 1.45.052 1.339-1.561 0 0 .052-.845-1.338-1.109s-4.679-.048-4.71-.048'
    />
    <path
      fill='#36A239'
      d='M24.633 9.155v1.436h1.668s.657-.202.62-.747a.77.77 0 0 0-.606-.696zM24.633 11.421v1.585h1.835s.73-.23.695-.83a.85.85 0 0 0-.663-.762z'
    />
  </svg>
);

